import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-arrow-up",
  "use": "icon-s-arrow-up-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-arrow-up\"><path fill-rule=\"evenodd\" d=\"M3.00028047 7.97167298 11.0092554-.000280465573 18.9997195 7.97167298 17.6607769 9.29210489 11.9286215 3.56303464 11.9286215 21.9997195 10.0868041 21.9626981 10.0868041 3.56303464 4.33922311 9.29210489z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol